import SimpleHeader from '../../../../components/Headers/SimpleHeader';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import ReactLoader from '../../../../components/Loader';
import BootstrapTable from 'react-bootstrap-table-next';
import BranchService from '../service';
import React, { useState, useEffect } from 'react';
import { CreateBranchModal } from '../form';
import Pagination from 'components/Pagination';
import { useHistory } from 'react-router-dom';
import { FaBoxes } from 'react-icons/fa';
import {
  Container,
  Row,
  Card,
  CardHeader,
  Button,
  Input,
  Col,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap';

import {
  icon_column_style,
  individual_column_style,
  individual_header_style
} from '../../../../assets/styles/table_custom_style';

const BranchList = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [timeoutID, setTimeoutID] = useState(null);
  const [id, setId] = useState(false);
  const history = useHistory();

  const handlePageChange = (activePage) => {
    setActivePage(activePage);
    getBranch(activePage);
  };

  async function getBranch(page, querySearch) {
    const size = 10;

    setIsLoading(true);

    await BranchService.getAllSearch(false, size, page, querySearch)
      .then((res) => {
        setQuantity(res.data.totalRegisters);

        setData(res.data.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const handleOnSearch = (event) => {
    if (typeof timeoutID === 'number') {
      clearTimeout(timeoutID);
    }
    const q = event.target.value;
    setTimeoutID(
      setTimeout(() => {
        getBranch(1, q);
      }, 1000)
    );
  };

  useEffect(() => {
    getBranch();
  }, []);

  return (
    <>
      <SimpleHeader
        CreateFunctionality={() => {
          setId(false);
          setIsModalOpen(!isModalOpen);
        }}
        name="Form validation"
        parentName="Forms"
        returnPath="/admin/dashboard"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">Filiais</h3>
                </CardHeader>

                <Row className="mt-3 mx-2">
                  <Col md="8">
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fas fa-search" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Busca por nome da filial"
                        type="text"
                        defaultValue=""
                        onChange={handleOnSearch}
                      />
                    </InputGroup>
                  </Col>
                  <Col md="4" className="text-right mt-2 mt-md-1">
                    <FormGroup check>
                      {/* <Label check>
                        <Input
                          type="checkbox"
                          // checked={showDisabled}
                          // onChange={() => setShowDisable(!showDisabled)}
                        />
                        <span>Mostar desabilitados</span>
                      </Label> */}
                    </FormGroup>
                  </Col>
                </Row>

                <ToolkitProvider
                  data={data}
                  keyField="uuid"
                  columns={[
                    {
                      dataField: 'id',
                      text: 'ID',
                      editable: false,
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'nome',
                      text: 'Nome',
                      editable: false,
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'empresa',
                      text: 'Empresa',
                      editable: false,
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'Estoque',
                      style: icon_column_style,
                      headerStyle: {
                        ...individual_header_style,
                        textAlign: 'center'
                      },
                      text: 'Estoque',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <Button
                            size="sm"
                            disabled={row.disable}
                            color="info"
                            onClick={() => {
                              history.push(`stock/${row.id}`);
                            }}
                          >
                            <FaBoxes></FaBoxes>
                          </Button>
                        );
                      }
                    },
                    {
                      dataField: 'Editar',
                      style: icon_column_style,
                      headerStyle: {
                        ...individual_header_style,
                        textAlign: 'center'
                      },
                      text: 'Editar',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <Button
                            size="sm"
                            disabled={row.disable}
                            color="info"
                            onClick={() => {
                              setIsModalOpen(!isModalOpen);
                              setId(row.id);
                            }}
                          >
                            <li className="fas fa-user-edit"></li>
                          </Button>
                        );
                      }
                    }
                  ]}
                >
                  {(props) => (
                    <div className="py-4 table-responsive">
                      {/* <SearchTable handleOnSearch={handleOnSearch} /> */}

                      <Row
                        style={{
                          display: `${isLoading ? 'flex' : 'none'}`,
                          justifyContent: 'center'
                        }}
                        className="justify-content-md-center"
                      >
                        <ReactLoader />
                      </Row>

                      <div
                        style={{ display: `${isLoading ? 'none' : 'initial'}` }}
                        className="py-4 table-responsive"
                      >
                        <BootstrapTable
                          {...props.baseProps}
                          bootstrap4={true}
                          keyField="id"
                          bordered={false}
                          classes="align-items-center"
                          noDataIndication="Nenhuma filial encontrado"
                          // selectRow={selectRow}
                        />
                      </div>
                    </div>
                  )}
                </ToolkitProvider>
                <Pagination
                  activePage={activePage}
                  totalItemsCount={quantity}
                  onChange={handlePageChange.bind(this)}
                />
              </Card>
            </div>
          </div>
        </Row>
        <CreateBranchModal
          show={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          id={id}
          setId={setId}
        />
      </Container>
    </>
  );
};

export default BranchList;
